import { useQueryClient } from '@tanstack/react-query'
import { Input, Select, Tag } from 'antd'
import StyledLoader from 'components/Elements/StyledLoader'
import StyledTooltip from 'components/Elements/StyledTooltip'
import { DataContext } from 'contexts/DataContextContainer'
import { useContext, useEffect, useState } from 'react'
import { Col, Row, Tab, Tabs } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { MdAddToQueue, MdHelp, MdRemoveFromQueue } from 'react-icons/md'
import { useMediaQuery } from 'react-responsive'
import { useParams } from 'react-router-dom'
import axiosClient from 'services/axios-client'
import { useBookQuery, useQuestionCatalogQuery } from 'store/queries'
import { breakpoints } from 'style'
import { PromptCatalogContainer } from './style'

const { TextArea } = Input
const { Option } = Select

// TODO: Split these out.
const LeftSide = ({
  isMobile,
  valuePromptToAdd,
  setValuePromptToAdd,
  unassignedItems,
  onSelectUnassignedItem,
  moveItemsToAssigned,
  filterTags,
  onFilterPromptsByTags,
  itemsToAssign,
  onAddNewPrompt,
}) => {
  const { t } = useTranslation()
  return (
    <>
      <div span={isMobile ? 24 : 12} className="prompts-left prompts-part">
        <div
          className={`custom-question-group textarea ${
            valuePromptToAdd.trim().length !== 0 && 'active'
          }`}
        >
          <div style={{ marginRight: '0.5px' }}>
            <div
              style={{
                backgroundColor: 'white',
                borderTopLeftRadius: '15px',
                borderTopRightRadius: '15px',
                padding: '20px 20px 5px 20px',
                height: '79px',
              }}
            >
              <h5 style={{ marginBottom: '0' }}>
                {t('add_your_own_custom_story_prompt')}{' '}
                <StyledTooltip
                  title={t('add_your_own_custom_story_prompt_tooltip')}
                  placement="bottom"
                >
                  <MdHelp size={30} style={{ color: '#4c4c4c' }} />
                </StyledTooltip>{' '}
              </h5>
            </div>
            <div
              className="prompt-add-wrapper w-100"
              style={{
                backgroundColor: 'white',
                borderBottomLeftRadius: '15px',
                borderBottomRightRadius: '15px',
                padding: '5px 20px 20px 20px',
              }}
            >
              <TextArea
                autoSize={{ minRows: 3, maxRows: 3 }}
                rows={3}
                className="prompt-add-input"
                placeholder={t('add_your_own_question')}
                value={valuePromptToAdd}
                onChange={(e) => setValuePromptToAdd(e.target.value)}
                maxLength={150}
                onPressEnter={(e) => e.preventDefault()}
              />
              <div className="icon-add-wrapper">
                <StyledTooltip
                  title={t('tt_add_custom_prompts_to_queue')}
                  placement="top"
                >
                  <MdAddToQueue
                    className={`ml-2 ${
                      valuePromptToAdd.trim().length === 0 && 'action-disable'
                    }`}
                    size={30}
                    onClick={onAddNewPrompt}
                    data-testid="add-custom-prompt-btn"
                  />
                </StyledTooltip>
              </div>
            </div>
          </div>
        </div>

        {/* <div style={{backgroundColor: "#f4f3f3", height: "20px"}}></div> */}
        <div
          className={`custom-question-group story ${
            itemsToAssign.length !== 0 && 'active'
          }`}
        >
          <div className="mobile-story-group" style={{ marginRight: '0.5px' }}>
            <div
              className="prompt-handler"
              data-testid="add-prompts-from-catalogue-btn"
            >
              <StyledTooltip
                title={t('tt_add_prompts_to_queue')}
                placement="top"
              >
                <MdAddToQueue
                  className={`${
                    itemsToAssign.length === 0 && 'action-disable'
                  }`}
                  size={30}
                  onClick={moveItemsToAssigned}
                />
              </StyledTooltip>
            </div>
            {!isMobile ? (
              <div
                className="p20"
                style={{
                  backgroundColor: 'white',
                  borderTopLeftRadius: '15px',
                  borderTopRightRadius: '15px',
                }}
              >
                <h5 style={{ float: 'left', marginRight: '20px' }}>
                  {t('story_prompt_catalogue')}{' '}
                  <StyledTooltip
                    title={t('story_prompt_catalogue_tooltip')}
                    placement="top"
                  >
                    <MdHelp size={30} style={{ color: '#4c4c4c' }} />
                  </StyledTooltip>{' '}
                </h5>
                <Select
                  defaultValue="All"
                  style={{ width: 220, marginBottom: 5 }}
                  onChange={onFilterPromptsByTags}
                >
                  {filterTags.map((_option, _i) => (
                    <Option key={_i} value={_option.value}>
                      {_option.label}
                    </Option>
                  ))}
                </Select>
              </div>
            ) : (
              <Select
                defaultValue="All"
                className={`selectbox-group ${
                  itemsToAssign.length !== 0 && 'active'
                }`}
                onChange={onFilterPromptsByTags}
              >
                {filterTags.map((_option, _i) => (
                  <Option key={_i} value={_option.value}>
                    {_option.label}
                  </Option>
                ))}
              </Select>
            )}

            <div className="prompt-items">
              {unassignedItems.map((item, _i) => (
                <div
                  key={_i}
                  className={`prompt-item prompt-item-border-top ${
                    itemsToAssign
                      .map((_item) => _item.question_id)
                      .includes(item.question_id) && 'selected'
                  }`}
                  onClick={() => onSelectUnassignedItem(item)}
                >
                  <div className="prompt-item">{item.dsply_text}</div>
                  <div className="prompt-item-tag">
                    {item.tags &&
                      typeof item.tags == 'string' &&
                      item.tags.split(',').map((_tag, _i) => (
                        <Tag
                          key={_i}
                          color={`${_tag.split(':')[1] || '#52725D'}`}
                          className="ml-2"
                        >
                          {_tag.split(':')[0]}
                        </Tag>
                      ))}
                  </div>
                </div>
              ))}
            </div>

            <div
              style={{
                backgroundColor: 'white',
                height: '20px',
                borderBottomLeftRadius: '15px',
                borderBottomRightRadius: '15px',
              }}
            ></div>
          </div>
        </div>
      </div>
    </>
  )
}

const RightSide = ({
  isMobile,
  unsentAssignedPrompts,
  onSelectAssignedItem,
  sentAssignedPrompts,
  itemsToUnassign,
  moveItemsToUnassigned,
}) => {
  const { t } = useTranslation()
  return (
    <div
      span={12}
      className={`prompts-right prompts-part ${
        itemsToUnassign.length !== 0 && 'active'
      }`}
    >
      <div className="chosen-story-group">
        <div style={{ marginLeft: '0.5px' }}>
          <div className="prompt-handler">
            <StyledTooltip
              title={t('tt_remove_prompts_from_queue')}
              placement="top"
            >
              <MdRemoveFromQueue
                className={`${
                  itemsToUnassign?.length === 0 && 'action-disable'
                }`}
                size={30}
                onClick={moveItemsToUnassigned}
              />
            </StyledTooltip>
          </div>
          {!isMobile && (
            <h5>
              {t('current_story_prompts')}{' '}
              <StyledTooltip
                title={t('chosen_story_prompts_tooltip')}
                placement="bottom"
              >
                <MdHelp size={30} style={{ color: '#4c4c4c' }} />
              </StyledTooltip>
            </h5>
          )}
          <div className="prompt-items">
            {sentAssignedPrompts.map((item, _i) => (
              <div
                key={_i}
                className={`prompt-item prompt-item-border-top ${
                  itemsToUnassign
                    .map((_item) => _item.question_id)
                    .includes(item.question_id) && 'selected'
                } ${item.is_sent && 'sent'}`}
                onClick={() => onSelectAssignedItem(item)}
              >
                <div className="prompt-item">{item.dsply_text}</div>
                <div className="prompt-item-tag">
                  {item.tags &&
                    typeof item.tags == 'string' &&
                    item.tags.split(',').map((_tag, _i) => (
                      <Tag
                        key={_i}
                        color={`${_tag.split(':')[1] || '#52725D'}`}
                        className="ml-2"
                      >
                        {_tag.split(':')[0]}
                      </Tag>
                    ))}
                </div>
              </div>
            ))}

            {!!unsentAssignedPrompts?.length && (
              <hr
                className="hr-text hr-blue"
                data-content={t('pending_prompts')}
              />
            )}

            {unsentAssignedPrompts.map((item, _i) => (
              <div
                key={_i}
                className={`prompt-item prompt-item-border-top ${
                  itemsToUnassign
                    .map((_item) => _item.question_id)
                    .includes(item.question_id) && 'selected'
                } ${item.is_sent && 'sent'}`}
                onClick={() => onSelectAssignedItem(item)}
              >
                <div className="prompt-item">{item.dsply_text}</div>
                <div className="prompt-item-tag">
                  {item.tags &&
                    typeof item.tags == 'string' &&
                    item.tags.split(',').map((_tag, _i) => (
                      <Tag
                        key={_i}
                        color={`${_tag.split(':')[1] || '#52725D'}`}
                        className="ml-2"
                      >
                        {_tag.split(':')[0]}
                      </Tag>
                    ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

function PromptCatalog() {
  const { lang, loggedInUser } = useContext(DataContext)
  const { bookId } = useParams()
  const queryClient = useQueryClient()
  const isMobile = useMediaQuery({
    query: `(max-width: ${breakpoints.sm}px)`,
  })

  const { data: book } = useBookQuery(bookId)

  const { data: questionCatalog } = useQuestionCatalogQuery(bookId)

  const [valuePromptToAdd, setValuePromptToAdd] = useState('')
  const [unassignedItems, setUnassignedItems] = useState([])
  const [sentAssignedPrompts, setSentAssignedPrompts] = useState([])
  const [unsentAssignedPrompts, setUnsentAssignedPrompts] = useState([])
  const [itemsToAssign, setItemsToAssign] = useState([])
  const [itemsToUnassign, setItemsToUnassign] = useState([])
  const [filterTags, setFilterTags] = useState([])

  // TODO: Move these out of state.
  useEffect(() => {
    if (questionCatalog) {
      const assignedTags = questionCatalog.filter(
        (tag) => tag.status !== 'Not Assigned',
      )

      assignedTags.sort((t1, t2) => t1.sort - t2.sort)

      const unsentTags = assignedTags.filter((at) => !at.is_sent)
      const sentTags = assignedTags.filter((at) => at.is_sent)

      setUnsentAssignedPrompts(unsentTags)
      setSentAssignedPrompts(sentTags)

      setUnassignedItems(
        questionCatalog.filter(
          (_item) =>
            _item.status === 'Not Assigned' && _item.question_type_id === 1,
        ),
      )
    }
  }, [questionCatalog])

  useEffect(() => {
    if (questionCatalog) {
      const updateFilterTags = () => {
        let _filterTags = []
        questionCatalog
          .map((t) => t.tags)
          .forEach((_tagStr) => {
            if (typeof _tagStr === 'string') {
              _tagStr.split(',').forEach((_ts) => {
                if (
                  !_filterTags
                    .map((_ft) => _ft.value)
                    .includes(_ts.split(':')[0])
                ) {
                  _filterTags.push({
                    value: _ts.split(':')[0],
                    label: _ts.split(':')[0],
                  })
                }
              })
            }
          })

        _filterTags.sort((t1, t2) => (t1.label > t2.label ? 1 : -1))
        _filterTags.unshift({
          value: 'All',
          label: lang === 'de' ? 'Alle' : 'All',
        })

        setFilterTags(_filterTags)
      }
      updateFilterTags()
    }
  }, [lang, questionCatalog])

  const onSelectAssignedItem = (item) => {
    if (item.is_sent) return
    let tmp = [...itemsToUnassign]

    if (tmp.map((_item) => _item.question_id).includes(item.question_id)) {
      tmp = tmp.filter((_item) => _item.question_id !== item.question_id)
    } else {
      tmp.push(item)
    }

    setItemsToUnassign(tmp)
  }

  const onSelectUnassignedItem = (item) => {
    let tmp = [...itemsToAssign]

    if (tmp.map((_item) => _item.question_id).includes(item.question_id)) {
      tmp = tmp.filter((_item) => _item.question_id !== item.question_id)
    } else {
      tmp.push(item)
    }

    setItemsToAssign(tmp)
  }

  const moveItemsToAssigned = async () => {
    if (itemsToAssign.length > 0) {
      const { ok } = await axiosClient.post(`/book/addSystemQuestions`, {
        book_id: book.id,
        question_ids: itemsToAssign.map((q) => q.id),
        user_id: loggedInUser.id,
      })
      if (ok) {
        queryClient.invalidateQueries({
          queryKey: ['book', bookId],
        })
        setItemsToAssign([])
        setItemsToUnassign([])
      }
    }

    if (itemsToAssign.length > 0) {
      let tmp = [...unsentAssignedPrompts]
      itemsToAssign.forEach((q) => {
        tmp.push(q)
      })

      setUnsentAssignedPrompts(tmp)
    }
  }

  const moveItemsToUnassigned = async () => {
    if (itemsToUnassign.length > 0) {
      const { ok } = await axiosClient.post(`/book/removeSystemQuestions`, {
        book_id: book.id,
        question_ids: itemsToUnassign.map((q) => q.id),
        user_id: loggedInUser.id,
      })
      if (ok) {
        queryClient.invalidateQueries({
          queryKey: ['book', bookId],
        })

        const filteredUnsent = unsentAssignedPrompts.filter(
          (item) =>
            !itemsToUnassign.some(
              (unassItem) => item.question_id === unassItem.question_id,
            ),
        )

        setUnsentAssignedPrompts(filteredUnsent)

        setItemsToAssign([])
        setItemsToUnassign([])
      }
    }
  }

  const onAddNewPrompt = async () => {
    if (valuePromptToAdd.trim().length > 0) {
      let params = {
        book_id: book.id,
        question: valuePromptToAdd.trim(),
        locale: lang,
      }

      const { ok } = await axiosClient.post(`/book/addCustomQuestion`, params)
      if (ok) {
        queryClient.invalidateQueries({
          queryKey: ['book', bookId],
        })

        setValuePromptToAdd('')
      }
    }
  }

  const onFilterPromptsByTags = (value) => {
    if (value === 'All') {
      setUnassignedItems(
        questionCatalog.filter(
          (_item) =>
            _item.status === 'Not Assigned' && _item.question_type_id === 1,
        ),
      )
    } else {
      setUnassignedItems(
        questionCatalog.filter((_item) => {
          if (
            _item.tags &&
            typeof _item.tags == 'string' &&
            _item.tags.split(',').find((_tag) => _tag.includes(value)) &&
            _item.status === 'Not Assigned' &&
            _item.question_type_id === 1
          ) {
            return _item
          } else {
            return false
          }
        }),
      )
    }
  }

  if (!book.id || !questionCatalog.length) {
    return <StyledLoader />
  }

  return (
    <PromptCatalogContainer isMobile={isMobile}>
      <div className="prompts">
        {!isMobile ? (
          <>
            <Row>
              <Col span={7}>
                <div
                  className="prompts-wrapper custom-body"
                  style={{ backgroundColor: '#f4f3f3' }}
                >
                  <LeftSide
                    isMobile={isMobile}
                    valuePromptToAdd={valuePromptToAdd}
                    setValuePromptToAdd={setValuePromptToAdd}
                    unassignedItems={unassignedItems}
                    onSelectUnassignedItem={onSelectUnassignedItem}
                    moveItemsToAssigned={moveItemsToAssigned}
                    filterTags={filterTags}
                    onFilterPromptsByTags={onFilterPromptsByTags}
                    itemsToAssign={itemsToAssign}
                    onAddNewPrompt={onAddNewPrompt}
                  />
                </div>
              </Col>
              <Col span={7}>
                <div
                  className="prompts-wrapper custom-body"
                  style={{ backgroundColor: '#f4f3f3' }}
                >
                  <RightSide
                    isMobile={isMobile}
                    unsentAssignedPrompts={unsentAssignedPrompts}
                    onSelectAssignedItem={onSelectAssignedItem}
                    sentAssignedPrompts={sentAssignedPrompts}
                    itemsToUnassign={itemsToUnassign}
                    moveItemsToUnassigned={moveItemsToUnassigned}
                  />
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <div className="prompts-wrapper custom-body">
            <Tabs defaultActiveKey="available" id="prompt-tabs">
              <Tab eventKey="available" title="Available">
                <LeftSide
                  isMobile={isMobile}
                  valuePromptToAdd={valuePromptToAdd}
                  setValuePromptToAdd={setValuePromptToAdd}
                  unassignedItems={unassignedItems}
                  onSelectUnassignedItem={onSelectUnassignedItem}
                  moveItemsToAssigned={moveItemsToAssigned}
                  filterTags={filterTags}
                  onFilterPromptsByTags={onFilterPromptsByTags}
                  itemsToAssign={itemsToAssign}
                  onAddNewPrompt={onAddNewPrompt}
                />
              </Tab>
              <Tab eventKey="current" title="Current">
                <RightSide
                  isMobile={isMobile}
                  unsentAssignedPrompts={unsentAssignedPrompts}
                  onSelectAssignedItem={onSelectAssignedItem}
                  sentAssignedPrompts={sentAssignedPrompts}
                  itemsToUnassign={itemsToUnassign}
                  moveItemsToUnassigned={moveItemsToUnassigned}
                />
              </Tab>
            </Tabs>
          </div>
        )}
      </div>
    </PromptCatalogContainer>
  )
}

export default PromptCatalog
